import isUndefined from 'lodash/isUndefined';

import { parseFormPostData } from '../api/utils';
import { socialLogIn as socialLogInApi } from '../api';

import {
    LOOKUP_SOCIAL_USER_EXISTENT,
    LOOKUP_SOCIAL_USER_EXISTENT_IN_SOFT_ACCOUNT,
    LOOKUP_SOCIAL_USER_EXISTENT_IN_FACEBOOK_SOFT_ACCOUNT,
    EXTERNAL_UNKNOWN_ERROR,
} from '../constants';

import { GA_APPLE } from '../constants/analytics';

import {
    trackLoginSuccessful,
    trackLoginSuccessOneStep,
    trackAppleNewAccount,
    trackAccountAutolinked,
} from './gaTracking';

import { getSocialLogInFormData } from './utils';

import { handleLoginSuccess } from './social';

import { lookupUser } from './lookup';

import {
    handleOnError,
    addSocialAuthenticationDataAction,
    setAccountExistent,
} from './auth';

export const handleAppleLoginAttempt = ({
    socialProvider,
    data,
    getState,
    dispatch,
}) => {
    const _data = getSocialLoginApiData({
        socialProvider,
        data,
    });
    const { email, sub } = data;

    dispatch(
        addSocialAuthenticationDataAction({
            socialAuthenticationData: { [socialProvider]: _data },
        }),
    );

    return dispatch(lookupUser({ email: email, socialProvider, sub })).catch(
        ({ message } = {}) => {
            if (
                message === LOOKUP_SOCIAL_USER_EXISTENT ||
                message === LOOKUP_SOCIAL_USER_EXISTENT_IN_SOFT_ACCOUNT ||
                message === LOOKUP_SOCIAL_USER_EXISTENT_IN_FACEBOOK_SOFT_ACCOUNT
            ) {
                return handleAppleSocialLogin({
                    data: _data,
                    getState,
                    dispatch,
                    socialProvider,
                    isSoftAccount:
                        message === LOOKUP_SOCIAL_USER_EXISTENT_IN_SOFT_ACCOUNT
                            ? true
                            : false,
                });
            } else if (isUndefined(message)) {
                handleOnError(dispatch)({
                    errors: { type: EXTERNAL_UNKNOWN_ERROR },
                });
            }
        },
    );
};

export const handleAppleSocialLogin = ({
    data,
    getState,
    dispatch,
    socialProvider,
    isSoftAccount = false,
}) => {
    const state = getState();

    return socialLogInApi(
        parseFormPostData(getSocialLogInFormData(data, getState)),
    )
        .then((response) => {
            if (response['is_account_autolinked'] === true) {
                if (isSoftAccount) {
                    trackAccountAutolinked({
                        state,
                        sourceProvider: GA_APPLE,
                        extraInfo: '_SoftAccount',
                    });
                } else {
                    trackAccountAutolinked({
                        state,
                        sourceProvider: GA_APPLE,
                        extraInfo: '_HardAccount',
                    });
                }
                trackLoginSuccessful({
                    sourceProvider: GA_APPLE,
                    state,
                });
            } else {
                trackAppleLoginSuccess(state, response);
            }

            return handleAppleLoginSuccess({
                state,
                data,
                response,
                dispatch,
            });
        })
        .catch(handleOnError(dispatch, state, data));
};

const trackAppleLoginSuccess = (state, response, actionCategory) => {
    if (response['new_user']) {
        trackAppleNewAccount({ state });
        trackLoginSuccessful({
            sourceProvider: GA_APPLE,
            state,
        });
    } else {
        trackLoginSuccessOneStep({
            sourceProvider: GA_APPLE,
            state,
            gaCategory: actionCategory,
        });
    }
};

const handleAppleLoginSuccess = ({ state, response, data, dispatch }) => {
    // Fresh account coming from the social provider
    // Scenario: appleFreshAccount, appleFreshAccount_AddingExistingAccount, appleFreshAccount_AddingSoftAccount
    dispatch(setAccountExistent(data.email));
    dispatch(
        addSocialAuthenticationDataAction({
            socialAuthenticationData: { apple: data },
        }),
    );

    handleLoginSuccess({ state, response, dispatch });
};

/**
 * Returns a useful data structure for the socialLogin api
 * @param {string} socialProvider
 * @param {object} data
 */
const getSocialLoginApiData = ({ socialProvider, data = {} }) => {
    const _data = {
        ...data,
        sourceProvider: socialProvider,
    };

    return _data;
};
